module.exports = __webpack_public_path__ + "static/media/spiffme-tm_600px.6c2c91fd.png";